import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import styles from "./info_dropdown.module.scss";
import { BsArrowRight } from "react-icons/bs";
import { CgMathMinus, CgMathPlus } from "react-icons/cg";

const InfoDropdown = ({
  data,
  customClasses,
  icon = "arrow",
  borderInside = true,
}) => {
  const [selected, setSelected] = useState(null);
  const toggle = (i) => {
    if (selected == i) {
      return setSelected(null);
    }
    setSelected(i);
  };

  return (
    <>
      {data?.map((item, i) => (
        <div
          className={`${styles.wrapper} ${
            customClasses?.root ? customClasses?.root : ""
          }`}
          key={item.id}
        >
          <div
            className={`${styles.title_wrapper} ${
              customClasses?.dropdown_title_wrapper
                ? customClasses?.dropdown_title_wrapper
                : ""
            }`}
            onClick={() => toggle(i)}
          >
            <p
              className={`${styles.title} ${
                customClasses?.dropdown_title
                  ? customClasses?.dropdown_title
                  : ""
              } ${selected == i ? `${styles.active}` : ""}`}
            >
              {item?.title}
              {item.list ? <span>{item.list.length} articles</span> : null}
            </p>

            {icon == "arrow" && (
              <>{selected == i ? <FiChevronUp /> : <FiChevronDown />}</>
            )}
            {icon == "plusMinus" && (
              <>{selected == i ? <CgMathMinus /> : <CgMathPlus />}</>
            )}
          </div>
          <Collapse in={selected == i} timeout="auto" unmountOnExit>
            <div
              className={`${styles.desc_wrapper} ${
                customClasses?.dropdown_description_wrapper
                  ? customClasses?.dropdown_description_wrapper
                  : ""
              }`}
            >
              {borderInside && <div className={styles.border}></div>}
              {item.list ? (
                item.list.map((text, i) => (
                  <p className={styles.list} key={i}>
                    <BsArrowRight className={styles.right_arrow} />
                    {text?.text}
                  </p>
                ))
              ) : (
                <p className={styles.desc}>{item?.description}</p>
              )}
            </div>
          </Collapse>
        </div>
      ))}
    </>
  );
};

export default InfoDropdown;
